import AnimatedBox from './Motion/AnimatedBox'

const Backdrop = ({ onClose, overlayVisible = true }: { onClose?: () => void, overlayVisible?: boolean }) => {
  return <AnimatedBox
    initial={{ opacity: 0 }}
    animate={{ opacity: 0.5 }}
    exit={{ opacity: 0 }}
    onClick={onClose}
    sx={{
      backgroundColor: overlayVisible ? 'black' : 'transparent',
      touchAction: 'none',
      position: 'fixed',
      top: 0,
      right: 0,
      width: '100%',
      height: '100%',
    }}>
  </AnimatedBox>
}

export default Backdrop
